var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemOnlineStatusElement = class PacemOnlineStatusElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._onlineHandler = (evt) => {
            if (!Utils.isNull(evt)) {
                this.online = evt.type === 'online';
            }
            else {
                this.online = navigator.onLine || false;
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('online', this._onlineHandler, false);
        window.addEventListener('offline', this._onlineHandler, false);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._onlineHandler();
    }
    disconnectedCallback() {
        window.removeEventListener('online', this._onlineHandler, false);
        window.removeEventListener('offline', this._onlineHandler, false);
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemOnlineStatusElement.prototype, "online", void 0);
PacemOnlineStatusElement = __decorate([
    CustomElement({ tagName: P + '-online-status' })
], PacemOnlineStatusElement);
export { PacemOnlineStatusElement };
//}
